import StateVisualization from './StateVisualization';
import './StateVisualization.scss';

export { schema, uiSchema } from '../schemas/StateVisualizationSchema';
export default StateVisualization;
